import { ReactNode } from 'react';

import { AlertTriangleIcon } from 'lucide-react';

import { Alert, AlertDescription } from '@/components/ui/alert';

interface Props {
  children: ReactNode;
}

export const WarningAlert = ({ children }: Props) => (
  <Alert variant="destructive">
    <AlertTriangleIcon size={16} />
    <AlertDescription className="gap-3 leading-5">{children}</AlertDescription>
  </Alert>
);
